<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="menu-table-container"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <div class="search-bar">
          <el-select
            v-model="searchParams.cate_id"
            placeholder="请选择分类"
            clearable
            style="width: 220px; margin-right: 10px"
          >
            <el-option
              v-for="item in cateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <el-button type="primary" icon="el-icon-search" @click="getList"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh" @click="resetSearch"
            >重置</el-button
          >
          <el-button type="success" icon="el-icon-plus" @click="handlePcAdd"
            >添加内容</el-button
          >
        </div>

        <el-table
        height="900"
          :data="tableData"
          border
          stripe
          style="width: 100%; margin-top: 20px"
          @row-click="handlePcRowClick"
        >
          <el-table-column label="ID" prop="id" width="80" align="center" />
          <el-table-column label="分类名称" prop="cate_name" min-width="150" />
          <el-table-column label="内容摘要" min-width="300">
            <template slot-scope="scope">
              <div v-html="getSummary(scope.row.content)"></div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="created_at" width="180" />
          <el-table-column label="更新时间" prop="updated_at" width="180" />

          <el-table-column
            label="操作"
            fixed="right"
            width="160"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                icon="el-icon-edit"
                @click.stop="handlePcEdit(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                icon="el-icon-delete"
                style="color: #f56c6c"
                @click.stop="handleDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.page"
          :page-size="searchParams.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageInfo.total"
          style="margin-top: 20px; text-align: right"
        ></el-pagination>

        <!-- PC 详情弹窗 -->
        <el-dialog
          title="内容详情"
          :visible.sync="pcShowCard"
          width="700px"
          center
          close-on-click-modal
          append-to-body
        >
          <div v-if="pcCurrentRow">
            <p><label>分类：</label>{{ pcCurrentRow.cate_name }}</p>
            <p><label>ID：</label>{{ pcCurrentRow.id }}</p>
            <p><label>创建时间：</label>{{ pcCurrentRow.created_at }}</p>
            <p><label>更新时间：</label>{{ pcCurrentRow.updated_at }}</p>
            <div style="margin-top: 15px;">
              <label>内容详情：</label>
              <div
                class="content-html"
                v-html="pcCurrentRow.content"
                style="max-height: 400px; overflow-y: auto; padding: 10px; border: 1px solid #eee; border-radius: 4px;"
              ></div>
            </div>
          </div>
        </el-dialog>

        <!-- PC 添加/编辑弹窗 -->
        <el-dialog
          :title="pcDialogType == 'add' ? '添加内容' : '编辑内容'"
          :visible.sync="pcDialogVisible"
          width="800px"
          @close="pcResetForm"
          append-to-body
        >
          <el-form
            :model="pcForm"
            :rules="addRules"
            ref="pcFormRef"
            label-width="110px"
          >
            <el-form-item label="选择分类" prop="cate_id">
              <el-select
                v-model="pcForm.cate_id"
                placeholder="请选择分类"
                style="width: 300px"
              >
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="内容编辑" prop="content">
              <quill-editor
                v-model="pcForm.content"
                ref="myQuillEditor"
                style="height: 400px;"
              />
            </el-form-item>
          </el-form>

          <!-- 修改点：调整按钮容器样式，确保按钮可见且可点击 -->
          <div slot="footer" class="dialog-footer">
            <el-button @click="pcDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="pcSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>

    <!-- ====================== 移动端 ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <div class="mobile-search-group">
          <el-select
            v-model="searchParams.cate_id"
            placeholder="选择分类"
            clearable
            size="medium"
            style="width: 100%"
          >
            <el-option
              v-for="item in cateList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
              >搜索</el-button
            >
            <el-button plain round @click="resetSearch" style="flex: 1"
              >重置</el-button
            >
            <el-button
              type="success"
              plain
              round
              @click="handleMobileAdd"
              style="flex: 1"
              >添加</el-button
            >
          </div>
        </div>

        <div class="mobile-card-list">
          <div
            class="mobile-card"
            v-for="item in tableData"
            :key="item.id"
            @click="handleMobileRowClick(item)"
          >
            <div class="card-header">
              <div class="info">
                <div class="title">{{ item.cate_name }}</div>
                <div class="meta">ID:{{ item.id }}</div>
              </div>
            </div>
            <div class="card-body">
              <div style="font-size: 12px; color: #666;">
                {{ getSummary(item.content) }}
              </div>
            </div>
            <div class="card-footer">
              <div style="font-size: 12px; color: #999;">
                {{ item.created_at }}
              </div>
              <div>
                <el-button
                  size="mini"
                  type="primary"
                  round
                  @click.stop="handleMobileEdit(item)"
                  >编辑</el-button
                >
              </div>
            </div>
          </div>
        </div>

        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="searchParams.page"
            :page-size="searchParams.page_size"
            layout="total, prev, pager, next, jumper"
            :total="pageInfo.total"
          />
        </div>

        <!-- 移动端详情 -->
        <el-dialog
          title="内容详情"
          :visible.sync="mobileShowCard"
          width="95%"
          top="8vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <div v-if="mobileCurrentRow" style="padding: 10px 0;">
            <el-descriptions :column="1" border size="small">
              <el-descriptions-item label="ID">{{ mobileCurrentRow.id }}</el-descriptions-item>
              <el-descriptions-item label="分类">{{ mobileCurrentRow.cate_name }}</el-descriptions-item>
              <el-descriptions-item label="创建时间">{{ mobileCurrentRow.created_at }}</el-descriptions-item>
              <el-descriptions-item label="更新时间">{{ mobileCurrentRow.updated_at }}</el-descriptions-item>
            </el-descriptions>
            <div style="margin-top: 15px;">
              <label>内容：</label>
              <div
                v-html="mobileCurrentRow.content"
                style="max-height: 400px; overflow-y: auto; padding: 10px; border: 1px solid #eee; border-radius: 4px;"
              ></div>
            </div>
          </div>
          <div slot="footer" style="text-align: right">
            <el-button @click="mobileShowCard = false">关闭</el-button>
          </div>
        </el-dialog>

        <!-- 移动端添加/编辑 -->
        <el-dialog
          :title="mobileDialogType == 'add' ? '添加内容' : '编辑内容'"
          :visible.sync="mobileDialogVisible"
          width="95%"
          top="10vh"
          custom-class="mobile-dialog"
          append-to-body
        >
          <el-form
            :model="mobileForm"
            :rules="addRules"
            ref="mobileFormRef"
            label-width="90px"
            size="small"
          >
            <el-form-item label="选择分类" prop="cate_id">
              <el-select
                v-model="mobileForm.cate_id"
                placeholder="请选择分类"
                style="width: 100%"
              >
                <el-option
                  v-for="item in cateList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="内容编辑" prop="content">
              <quill-editor
                v-model="mobileForm.content"
                style="height: 300px;"
              />
            </el-form-item>
          </el-form>
          <!-- 修改点：调整移动端按钮容器样式 -->
          <div
            slot="footer"
            class="dialog-footer mobile-dialog-footer"
          >
            <el-button size="medium" @click="mobileDialogVisible = false">取消</el-button>
            <el-button type="primary" size="medium" @click="mobileSubmitForm">确认提交</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/api.js";
// 富文本编辑器（确保项目已安装并引入）
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
export default {
  name: "ContentList",
  components: { quillEditor },
  data() {
    return {
      loading: false,
      tableData: [],
      pageInfo: { total: 0 },
      cateList: [],
      searchParams: {
        page: 1,
        page_size: 10,
        cate_id: "",
      },

      // 验证
      addRules: {
        cate_id: [{ required: true, message: "请选择分类", trigger: "change" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },

      // PC
      pcShowCard: false,
      pcCurrentRow: null,
      pcDialogVisible: false,
      pcDialogType: "add",
      pcForm: {
        cate_id: "",
        content: "",
      },

      // 移动端
      mobileShowCard: false,
      mobileCurrentRow: null,
      mobileDialogVisible: false,
      mobileDialogType: "add",
      mobileForm: {
        cate_id: "",
        content: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true;
      api.contentList
        .index({ params: this.searchParams })
        .then((res) => {
          if (res.data.code == 1000) {
            this.tableData = res.data.data.data || [];
            this.cateList = res.data.data.cate || [];
            this.pageInfo.total = res.data.data.total || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 删除
    handleDel(row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        api.contentList
          .del({ content_id: row.id })
          .then((res) => {
            if (res.data.code == 1000) {
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // 摘要
    getSummary(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      let text = div.innerText || "";
      if (text.length > 50) text = text.substring(0, 50) + "...";
      return text;
    },

    // ==================== PC ====================
    handlePcRowClick(row) {
      this.pcCurrentRow = row;
      this.pcShowCard = true;
    },
    handlePcAdd() {
      this.pcDialogType = "add";
      this.pcResetForm();
      this.pcDialogVisible = true;
    },
    handlePcEdit(row) {
      this.pcDialogType = "edit";
      this.pcForm = {
        cate_id: row.content_cate_id,
        content: row.content,
        content_id: row.id,
      };
      this.pcDialogVisible = true;
    },
    pcResetForm() {
      this.pcForm = { cate_id: "", content: "", content_id: "" };
      this.$nextTick(() => {
        if (this.$refs.pcFormRef) this.$refs.pcFormRef.clearValidate();
      });
    },
    pcSubmitForm() {
      this.$refs.pcFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn = this.pcDialogType == "add" ? api.contentList.add : api.contentList.edit;
        fn(this.pcForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.pcDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 移动端 ====================
    handleMobileRowClick(row) {
      this.mobileCurrentRow = row;
      this.mobileShowCard = true;
    },
    handleMobileAdd() {
      this.mobileDialogType = "add";
      this.mobileResetForm();
      this.mobileDialogVisible = true;
    },
    handleMobileEdit(row) {
      this.mobileDialogType = "edit";
      this.mobileForm = {
        cate_id: row.content_cate_id,
        content: row.content,
        content_id: row.id,
      };
      this.mobileDialogVisible = true;
    },
    mobileResetForm() {
      this.mobileForm = { cate_id: "", content: "", content_id: "" };
      this.$nextTick(() => {
        if (this.$refs.mobileFormRef) this.$refs.mobileFormRef.clearValidate();
      });
    },
    mobileSubmitForm() {
      this.$refs.mobileFormRef.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        const fn = this.mobileDialogType == "add" ? api.contentList.add : api.contentList.edit;
        fn(this.mobileForm)
          .then((res) => {
            if (res.data.code == 1000) {
              this.mobileDialogVisible = false;
              this.getList();
            }
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    // ==================== 公共 ====================
    resetSearch() {
      this.searchParams = {
        page: 1,
        page_size: 10,
        cate_id: "",
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getList();
    },
  },
};
</script>

<style scoped>
/* PC */
.menu-table-container {
  padding: 20px;
}
.search-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.content-html {
  font-size: 14px;
  line-height: 1.7;
}

/* 弹窗按钮样式，解决点击不到的问题 */
.dialog-footer {
  text-align: right;
  padding-top: 15px;
  margin-top: 10px;
}
.dialog-footer .el-button {
  margin-left: 10px;
}

/* 移动端 */
.mobile-goods-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  margin-bottom: 8px;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.card-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}
.mobile-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/content/cobtent.vue